import { render, staticRenderFns } from "./PuntosVentaEvento.vue?vue&type=template&id=007e2790&"
import script from "./PuntosVentaEvento.vue?vue&type=script&lang=js&"
export * from "./PuntosVentaEvento.vue?vue&type=script&lang=js&"
import style0 from "./PuntosVentaEvento.vue?vue&type=style&index=0&id=007e2790&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports